import { render } from "./MedioColor.vue?vue&type=template&id=0a2b2142&scoped=true"
import script from "./MedioColor.vue?vue&type=script&lang=js"
export * from "./MedioColor.vue?vue&type=script&lang=js"

import "./MedioColor.vue?vue&type=style&index=0&id=0a2b2142&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a2b2142"]])

export default __exports__